import(/* webpackMode: "eager" */ "/app/app/(routes)/(homepage)/[workspace]/page.tsx");
